import { ApiShopperLandingPage } from '@storefronts/common-types'
import Script from 'next/script'

export const RockerboxPixel: React.FC<{
    landingPage: ApiShopperLandingPage
}> = ({ landingPage }) => {
    const pixelId = landingPage.integrations.rockerboxPixelId
    const pixelUrl = landingPage.integrations.rockerboxPixelUrl

    if (!pixelId || !pixelUrl) return null

    return (
        <Script id="rockerbox-pixel" strategy="afterInteractive">
            {`
                (function(d,RB) {if (!window.RB) { window.RB=RB;RB.queue=RB.queue||[];RB.track=RB.track||function(){RB.queue.push(Array.prototype.slice.call(arguments))};RB.initialize=function(s){RB.source=s};var a = d.createElement("script"); a.type="text/javascript"; a.async=!0; a.src="${pixelUrl}"; f=d.getElementsByTagName("script")[0]; f.parentNode.insertBefore(a,f);} } )(document,window.RB || {}); 
                RB.disablePushState=true; 
                RB.initialize('${pixelId}'); 
                RB.track("view"); 
            `}
        </Script>
    )
}
